import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {connect} from "react-redux";
import {
  patchMobileAppsLink,
} from 'redux/links/actions';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';

import './MobileAppLinkButtonTypeSelector.css';


class MobileAppLinkButtonTypeSelector extends Component {
  static propTypes = {
    patchMobileAppsLink: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    defaultColor: PropTypes.string.isRequired,
    parameter: PropTypes.string.isRequired,
    pickerId: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    linkId: PropTypes.number.isRequired,
    initialColor: PropTypes.string.isRequired,
  }

  state = {
    currentColor: null,
  };

  componentDidMount() {
    this.setState({ currentColor: this.props.initialColor });
  }

  _onColorChange = color => {
    this.setState({ currentColor: color.hex });
    const form = new FormData();
    form.append(this.props.parameter, color.hex);
    this.props.patchMobileAppsLink(
      this.props.linkId,
      form,
    );
  };

  render() {
    const { label, defaultColor, pickerId, key } = this.props;
    const { currentColor } = this.state;

    return (
      <div className="mobile-app-link-button-style-selector__component">
        <div className="picker-wrapper">
          <ColorPicker
            mini
            key={`color-picker-key-${key}`}
            pickerId={pickerId}
            color={currentColor || defaultColor}
            onChangeComplete={this._onColorChange}
            disableAlpha
          />
        </div>

        <div className="info-wrapper">
          <div className="color-hex">{currentColor}</div>
          <div className="label">{label}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchMobileAppsLink,
  },
)(MobileAppLinkButtonTypeSelector);
